import React, { Component } from "react";
import { Link } from "react-router-dom";
import ContentLoader from "../../Static/contentLoader";
import { t } from "react-multi-lang";
import {
  fetchNotificationInbox,
  markNotificationsRead,
} from "../../Notifications/notificationCenterApi";

/**
 * Full unified notification inbox — same source as NotificationBell.
 */
class Notifications extends Component {
  state = {
    loadingNotification: true,
    items: [],
    unreadCount: 0,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const data = await fetchNotificationInbox({ take: 50 });
    this.setState({
      loadingNotification: false,
      items: (data && data.items) || [],
      unreadCount: (data && data.unread_count) || 0,
    });
  };

  markOne = async (id) => {
    await markNotificationsRead({ notificationId: id });
    this.load();
  };

  formatTime(value) {
    if (!value) return "";
    try {
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";
      return d.toLocaleString();
    } catch (e) {
      return "";
    }
  }

  render() {
    if (this.state.loadingNotification) {
      return <ContentLoader />;
    }

    const { items } = this.state;

    return (
      <div className="main p-40 padding-top-lg">
        <div className="main-slidersec">
          <h3 className="">{t("view_all_notification") || "Notifications"}</h3>
          {items.length === 0 ? (
            <p className="text-muted mt-3">No notifications</p>
          ) : (
            <ul className="list-unstyled mt-3">
              {items.map((n) => (
                <li
                  key={n.id || n.uuid}
                  style={{
                    opacity: n.read_status === "read" ? 0.7 : 1,
                    padding: "0.75rem 0",
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  {n.action_url ? (
                    <Link to={n.action_url} onClick={() => this.markOne(n.id)}>
                      <strong>{n.title}</strong>
                    </Link>
                  ) : (
                    <strong onClick={() => this.markOne(n.id)}>{n.title}</strong>
                  )}
                  {n.body ? <p className="mb-1 small">{n.body}</p> : null}
                  {n.created_at ? (
                    <p className="mb-0 small text-muted">
                      {this.formatTime(n.created_at)}
                    </p>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="height-100" />
      </div>
    );
  }
}

export default Notifications;
